$(function () {
  const memberPerksSection = `
        <div class="member-perks-section">
            <div class="member-perks-container">
                <div class="common-title">
                    <h2>Member-Only Perks</h2>
                </div>
                <div class="member-perk-wrapper">
                    <div class="member-perks-image">
                        <img src="//carrotstick.com/cdn/shop/files/CSR-EYEESSENTIALS_34bc7dfb-2a09-42d7-8a09-3e5658722b14.png?v=1720590917&amp;width=800" alt="Member Perks" loading="lazy">
                    </div>
                    <div class="member-perks-content">
                        <div class="perk-item">
                            <h3>15% Off Everything Always</h3>
                            <p>Just log in to your account and save 15% sitewide. Automatically applied at checkout.</p>
                        </div>
                        <div class="perk-item">
                            <h3>$47 Monthly Credit</h3>
                            <p>A $47 USD charge will be credit back to your account. This will accumulate throughout the year.</p>
                        </div>
                        <div class="perk-item">
                            <h3>Exclusive Offers</h3>
                            <p>You'll receive free full size gifts, exclusive promos and much more.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;

  const howItWorksSection = `
    <div class="how-it-works-section">
        <div class="how-it-works-inner">
            <h2 class="common-title">How It Works</h2>
            <p class="sub">A membership that pays for itself from day one.</p>
            <div class="how-it-works-steps">
                <div class="step">
                    <span class="number">1</span>
                    <div>
                        <h3>Join the Membership</h3>
                        <p>Add a membership to your cart and checkout.</p>
                    </div>
                </div>
                <div class="step">
                    <span class="number">2</span>
                    <div>
                        <h3>Access Benefits Instantly</h3>
                        <p>Get full access to the benefits on your order today and any in the future. Just log in to access your benefits in the future.</p>
                    </div>
                </div>
                <div class="step">
                    <span class="number">3</span>
                    <div>
                        <h3>Enjoy the Savings</h3>
                        <p>Let the store credit and discounts pile up. You've earned it.</p>
                    </div>
                </div>
            </div>
            <div class="how-it-works-button">
                <a href="/pages/membership" class="membership--button large" data-type="from-membership-page">Become a Member Save 15%</a>
            </div>
            <p class="login-text">
                Already a member? <a href="/account" style="color: #000;text-decoration: underline;text-transform: uppercase;">Login here.</a>
            </p>
        </div>
    </div>
    `;

  // Append Member Perks section
  $(".inveterate__hero").after(memberPerksSection);

  // Append How It Works section ONLY if Member Perks section exists
  if ($(".member-perks-section").length > 0) {
    $(".member-perks-section").after(howItWorksSection);
  }

  const joinButton = `
    <a href="" class="membership--button" data-type="from-membership-page">
      Become a Member Save 15%
    </a>
  `;

  $(".inveterate__hero__copy").after(joinButton);

  const subTitleContent = `
    <div class="membership-subtext">$47/mo USD charge that is applied to future orders as a credit</div>
  `;
  const backToAccountLink = `
  <a href="/account" style="color: #7E7E7E; text-decoration: none; font-size: 16px;">
            <svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 6px">
              <path d="M6 10.1668L1.33333 5.50016L6 0.833496" stroke="#7E7E7E" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            Back to account
          </a>
  `;

  const $firstButton = $(".membership--button").first();
  const $welcomeTitle = $("h2.inveterate__member__headline").first();

  if ($firstButton.length > 0) {
    $firstButton.after(subTitleContent);
  }

  if ($welcomeTitle.length > 0) {
    $welcomeTitle.after(backToAccountLink);
  }

  $(
    'a.inveterate__membership__link[data-inveterate-modal-trigger="cancel-message"]'
  ).text("Cancel Membership");

  $(
    'a.inveterate__membership__link[data-inveterate-action="open-tier-selection"]'
  ).hide();
});
